import React from "react";
import { Modal, ModalHeader, ModalBody, Button, Row, Col } from "reactstrap";
import { Formik, Form, Field } from "formik";
import { useDispatch } from "react-redux";
import { addCommissionManually } from "../../../slices/admin/thunk";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";

const AddCommissionModal = ({ open, setOpen, onRefresh }) => {
  const dispatch = useDispatch();
  const { id: dashboardUserId } = useParams();

  const toggleModal = () => {
    setOpen(!open);
  };

  const initialValues = {
    amount: "",
    description: "",
  };

  const validationSchema = Yup.object({
    amount: Yup.number()
      .required("Amount is required")
      .positive("Must be a positive number"),
    description: Yup.string().required("Description is required"),
  });

  const handleAddCommission = async (values, { setSubmitting, resetForm }) => {
    try {
      Swal.fire({
        title: "Adding commission...",
        text: "Please wait",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const response = await dispatch(
        addCommissionManually({
          dashboardUserId,
          ...values,
        })
      );
      console.log("response ", response);
      const res = response.payload;
      if (res && !res.error) {
        Swal.fire({
          icon: "success",
          title: "Commission added successfully!",
          showConfirmButton: false,
          timer: 1500,
        });

        setSubmitting(false);
        resetForm();
        onRefresh();
        toggleModal();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error adding commission",
          showConfirmButton: false,
          timer: 1500,
        });
        setSubmitting(false);
      }
    } catch (error) {
      console.error("Error adding commission:", error);
      Swal.fire({
        icon: "error",
        title: "Error adding commission",
        showConfirmButton: false,
        timer: 1500,
      });
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen={open} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>Add New Commission</ModalHeader>
      <ModalBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleAddCommission}
        >
          {({ isSubmitting, dirty, isValid }) => (
            <Form>
              <Row className="mb-3">
                <Col>
                  <label>Amount (in cents)</label>
                  <Field name="amount" type="number" className="form-control" />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col>
                  <label>Description</label>
                  <Field
                    name="description"
                    as="textarea"
                    className="form-control"
                  />
                </Col>
              </Row>
              <Row>
                <Col className="col-6">
                  <Button
                    color="soft-primary"
                    className="border border-primary w-100"
                    onClick={toggleModal}
                  >
                    Cancel
                  </Button>
                </Col>
                <Col className="col-6">
                  <Button
                    type="submit"
                    color="primary"
                    className="w-100"
                    disabled={isSubmitting || !dirty || !isValid}
                  >
                    {isSubmitting ? (
                      <div className="spinner-border spinner-border-sm"></div>
                    ) : (
                      "Save"
                    )}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default AddCommissionModal;
